export const SET_CHANNEL_IDENTITIES = 'SET_CHANNEL_IDENTITIES';
